export default __webpack_public_path__ + "static/media/FrenchCanon.0be2bba5.woff2";